import React from 'react';
import {connect} from 'react-redux'
import Paper from 'material-ui/Paper';

import * as colors from 'material-ui/styles/colors';

import PageBase from '../../../components/PageBase';

import gStyles from '../../../styles'

import * as actions from '../../../actions'
import BizHolidayMasterForm from './BizHolidayMasterForm'

class BizHolidayMasterPage extends React.Component {

  constructor(props) {
    super(props)
  }

  componentDidMount() {
    this.props.handleInit()
  }

  render() {

    const {
      form,
      handleRemoveDate,
      handleRegist,
      handleChangeYear,
    } = this.props

    return (

      <PageBase title="休日マスタ" >

        <div>

          <Paper style={{...gStyles.searchBoxContainer}}>
            <BizHolidayMasterForm 
              initialValues={form}
              onRemoveDate={handleRemoveDate}
              onRegist={handleRegist}
              onChangeYear={handleChangeYear}
            />
          </Paper>

        </div>

      </PageBase>

    )
  }

}

const mapStateToProps = (state) => ({
  form: state.bizHoliday.form
})

const mapStateToDispatch = (dispatch) => ({
  handleInit : () => {dispatch(actions.systemBizHolidayInit())},
  handleRemoveDate : (month, index, list) => {
    dispatch(actions.reducerBizHolidayRemoveDate(month, index, list))
  },
  handleRegist : (form) => {
    dispatch(actions.userBizHolidayRegist(form))
  },
  handleChangeYear : (year) => {
    dispatch(actions.userBizHolidayChangeYear(year))
  },
})

BizHolidayMasterPage = connect(
  mapStateToProps,
  mapStateToDispatch
)(BizHolidayMasterPage)

export default BizHolidayMasterPage;



// WEBPACK FOOTER //
// ./src/containers/master/bizHoliday/BizHolidayMasterPage.js